(() => {
  const selectors = [
    '.firefly-recommendations__heading',
    '.firefly-recommendations__card',
    '.firefly-scroll-pic__copy',
    '.firefly-intelligent-ecosystem__heading',
    '.firefly-intelligent-ecosystem__subheading',
    '.firefly-intelligent-ecosystem__hero',
    '.firefly-intelligent-ecosystem__panel',
    '.firefly-delivery-system__heading',
    '.firefly-delivery-system__card',
    '.firefly-open-source-ecosystem__heading',
    '.firefly-open-source-ecosystem__text',
    '.firefly-open-source-ecosystem__logos',
    '.firefly-open-source-ecosystem__mobile-carousel',
    '.firefly-discover__header',
    '.firefly-cta-banner__text',
    '.firefly-cta-banner__button',
    '.firefly-support-methods__card',
    /* 当前首页新区块 */
    '.firefly-hot-picks__heading',
    '.firefly-hot-picks__card',
    '.firefly-eco-advantages__heading',
    '.firefly-eco-advantages__text',
    '.firefly-eco-advantages__banner',
    '.firefly-eco-advantages__card',
    '.firefly-open-source__heading',
    '.firefly-open-source__text',
    '.firefly-open-source__carousel',
    '.firefly-open-source__logo-card',
    '.firefly-why-firefly__heading',
    '.firefly-why-firefly__desc',
    '.firefly-why-firefly__video',
    '.firefly-why-firefly__stats',
    '.firefly-cform__heading',
    '.firefly-cform__desc',
    '.firefly-cform__checks',
    '.firefly-cform__card'
  ];

  const scaleSelectors = [
    '.firefly-recommendations__card',
    '.firefly-intelligent-ecosystem__hero',
    '.firefly-intelligent-ecosystem__panel',
    '.firefly-delivery-system__card',
    '.firefly-discover__card',
    '.firefly-support-methods__card',
    /* 当前首页新区块：整卡/大图用缩放淡入 */
    '.firefly-hot-picks__card',
    '.firefly-eco-advantages__banner',
    '.firefly-why-firefly__video',
    '.firefly-cform__card'
  ];

  const staggerParents = [
    '.firefly-recommendations__track',
    '.firefly-intelligent-ecosystem__grid',
    '.firefly-delivery-system__grid',
    '.firefly-open-source-ecosystem__logos',
    '.firefly-discover__track',
    '.firefly-support-methods__grid',
    /* 当前首页新区块：卡片逐个 80ms 延迟 */
    '.firefly-hot-picks__track',
    '.firefly-eco-advantages__grid',
    '.firefly-eco-advantages__card-list',
    '.firefly-open-source__track'
  ];

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealItems = Array.from(document.querySelectorAll(selectors.join(',')));
  const discoverCards = Array.from(document.querySelectorAll('.firefly-discover__card'));
  const items = [...revealItems, ...discoverCards];

  if (!items.length || motionQuery.matches) return;

  const scaleMatcher = (element) => scaleSelectors.some((selector) => element.matches(selector));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.16
  });

  staggerParents.forEach((parentSelector) => {
    document.querySelectorAll(parentSelector).forEach((parent) => {
      Array.from(parent.children).forEach((child, index) => {
        child.style.setProperty('--firefly-reveal-delay', `${Math.min(index * 80, 320)}ms`);
      });
    });
  });

  document.querySelectorAll('.firefly-discover__track').forEach((parent) => {
    Array.from(parent.children).forEach((child, index) => {
      child.style.setProperty('--firefly-reveal-delay', `${Math.min(index * 140, 420)}ms`);
    });
  });

  document.body.classList.add('firefly-home-animations-ready');

  items.forEach((item) => {
    item.classList.add('firefly-home-reveal');
    if (scaleMatcher(item)) {
      item.classList.add('firefly-home-reveal--scale');
    } else {
      item.classList.add('firefly-home-reveal--soft');
    }
  });

  revealItems.forEach((item) => {
    observer.observe(item);
  });

  if (discoverCards.length) {
    const discoverObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        discoverCards.forEach((card) => card.classList.add('is-visible'));
        discoverObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -18% 0px',
      threshold: 0.18
    });

    document.querySelectorAll('.firefly-discover').forEach((section) => {
      discoverObserver.observe(section);
    });
  }
})();
